export default __webpack_public_path__ + "static/media/pooperpunk.ce92ae0f.png";